import React from 'react';
import { FormattedMessage } from 'react-intl';

import { useIdelinkTheme } from '../../../../../xlink/configs/IdeLinkTheme';
import {
	TabPermissionItem,
} from '../../../../../xlink/modules/BackUsers/Pages/components/PermissionsTreeContainer/PermissionsTreeContainer';
import { AdminPermission } from '../../../../../xlink/services/commons/Me';
import {
	AdminPermissions,
	AdminPermissionsOnModule,
} from '../../../../../xlink/services/commons/Permissions/AdminPermissions';
import { PermissionsAbilityHelper } from '../../../../../xlink/services/commons/Permissions/PermissionsAbilityHelper';
import { ETribuTheme } from '../../../Config/ETribuAppTheme';

export class ETribuCoursesPermissions {
	public static ETRIBU_COURSES_TAB_HASH = '#rights-courses';
	public static ETRIBU_COURSES_CODE = 'SylvieThiriezCourses';

	public static Admin: AdminPermissionsOnModule = {};

	public static getETribuCoursesTab = (): TabPermissionItem => ({
		hash: ETribuCoursesPermissions.ETRIBU_COURSES_TAB_HASH,
		label: (
			<FormattedMessage id="backofficeUsers.create.tabs.permissions.sectionTabs.courses" />
		),
		getIcon: () => useIdelinkTheme<ETribuTheme>().courses.permissionIcon,
		getIconSelected: () => useIdelinkTheme<ETribuTheme>().courses.permissionSelectedIcon,
	});

	public static initializeETribuCoursesAdminPermissions = (
		perms: Array<AdminPermission> = []
	) => {
		const permsOnETribuCourses = AdminPermissions.filter(
			perms,
			ETribuCoursesPermissions.ETRIBU_COURSES_CODE
		);
		ETribuCoursesPermissions.Admin = AdminPermissions.toPermissions(permsOnETribuCourses);
		PermissionsAbilityHelper.logPermissions(
			'SylvieThiriezCourses',
			ETribuCoursesPermissions.Admin
		);
	};
}
